import { lazy, Suspense } from 'react';
import { useLocation } from 'react-router-dom';
import { useMaintenanceMode } from '@/hooks/useMaintenanceMode';
import { useAdmin } from '@/hooks/useAdmin';
import { LoadingScreen } from './LoadingScreen';

const Maintenance = lazy(() => import('@/pages/Maintenance'));

interface MaintenanceWrapperProps {
  children: React.ReactNode;
}

export const MaintenanceWrapper = ({ children }: MaintenanceWrapperProps) => {
  const location = useLocation();
  const { isEnabled, message, isLoading: maintenanceLoading } = useMaintenanceMode();
  const { isAdmin, isLoading: adminLoading } = useAdmin();

  // Allow access to auth and admin routes even during maintenance
  const isAuthRoute = location.pathname.includes('/auth');
  const isAdminRoute = location.pathname.includes('/admin');

  if (maintenanceLoading || adminLoading) {
    return <LoadingScreen />;
  }

  // Show maintenance page if enabled, user is not admin, and not on auth/admin routes
  if (isEnabled && !isAdmin && !isAuthRoute && !isAdminRoute) {
    return (
      <Suspense fallback={<LoadingScreen />}>
        <Maintenance message={message} />
      </Suspense>
    );
  }

  return <>{children}</>;
};
